'use strict';

/* globals angular */

const SignupEmbedDirective = require('./SignupEmbedDirective');

const signupForm = angular.module('login.signupEmbed', [
  'stripe.checkout'
]);

signupForm.directive('signupEmbed', [
  SignupEmbedDirective
]);

signupForm.service('plansRequest', ['$http', 'IdentityService', function ($http, IdentityService) {

  const url = IdentityService.getPaymentsApiUri() + 'plans';
  const httpConfig = { url, method: 'GET' };
  return $http(httpConfig);
}]);

signupForm.run(['StripeCheckout', 'stripe_public', function (StripeCheckout, stripe_public) {

  StripeCheckout.defaults({
    key: stripe_public,
    image: 'https://s3.amazonaws.com/stripe-uploads/acct_16weuNLNU1nugEFWmerchant-icon-1449606075085-skycatch_logo_round.png',
    locale: 'auto'
  });
}]);



// WEBPACK FOOTER //
// ./src/app/login/signupFormEmbed/index.js